<template>
  <section class="wrapper__business-woocommerce-add px-4">
    <b-row>
      <b-col xs="12" lg="12">
        <h4 class="h4 font-semi-bold mb-4">
          Integración con Facturación
        </h4>
        <el-form :model="form" :rules="rules" ref="form">
          <b-row>
            <b-col xs="12" sm="12" md="12">
              <el-form-item prop="emision_point_id" class="mb-4">
                <SelectEmissionPointsComponent
                  @onChangeSelect="onChangeSelectEmissionPoints"
                  :setEmissionPointId="form.emision_point_id"
                />
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col xs="12" sm="12" md="12">
              <el-form-item prop="token" class="mb-4">
                <slot name="label">
                  <label class="font-semi-bold m-0">Token </label>
                </slot>
                <el-input
                  placeholder=""
                  type="textarea"
                  class=""
                  v-model="form.token"
                  :autosize="{ minRows: 4, maxRows: 8 }"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col xs="12" sm="12" md="12">
              <el-form-item prop="generate" class="mb-4">
                <el-checkbox v-model="form.generate" class="font-semi-bold">
                  Generar nuevo token
                  <small class="text-muted">
                    (**Al generar un nuevo token, se revocará automáticamente el
                    anterior)
                  </small>
                </el-checkbox>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col xs="12" sm="12">
              <ButtonPrimaryComponent
                class="float-right mt-4"
                title="Generar"
                @onSaveClick="handleSaveClick"
              />
            </b-col>
          </b-row>
        </el-form>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import ButtonPrimaryComponent from "@/modules/dashboard/components/ButtonPrimary";
import SelectEmissionPointsComponent from "../../../../components/SelectEmissionPoints";
import tradeService from "../../../services/tradeService";

export default {
  name: "InvoiceApi",
  data() {
    return {
      form: {
        business_id: "",
        token: "",
        emision_point_id: "",
        generate: false
      },
      rules: {
        token: []
      }
    };
  },
  computed: {
    getUser() {
      return this.$store.getters.getUser;
    }
  },
  watch: {},
  methods: {
    onChangeSelectEmissionPoints({ emissionPointId }) {
      this.form.emision_point_id = emissionPointId;
    },
    async getIntegrationsInvoice() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        let response = await tradeService
          .getIntegrationsInvoice()
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        const { success, data } = response.data;
        if (success) {
          this.form = {
            ...this.form,
            ...data
          };
        }
      } catch (error) {
        return false;
      }
    },
    handleSaveClick() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.$store.dispatch("toggleRequestLoading");
          try {
            this.form.business_id = this.getUser.user_business.id;
            let response = await tradeService
              .addIntegrationsInvoice(this.form)
              .finally(() => {
                this.$store.dispatch("toggleRequestLoading");
              });
            const { success, message, token, emision_point_id } = response.data;
            if (success) {
              this.form = {
                token,
                emision_point_id,
                generate: false
              };
              this.$notifications.success({
                message
              });
            }
          } catch (error) {
            return false;
          }
        }
      });
    }
  },
  components: {
    ButtonPrimaryComponent,
    // MoreInfoComponent,
    SelectEmissionPointsComponent
    // InputDatePickerComponent,
    // ButtonComponent
  },
  props: {},
  mounted() {
    this.getIntegrationsInvoice();
  }
};
</script>

<style lang="scss" scoped></style>
